import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Title from '../../components/Title/Title';
import { isHelpCenterCategory } from '../../utils/helpCenterCategories';
import HelpCenterLayout, { useHelpCenterCatalogContext } from './HelpCenterLayout';

const CategoryArticleList = ({ category }: { category: string }) => {
  const { t } = useTranslation();
  const { articles, status } = useHelpCenterCatalogContext();

  if (status === 'loading') {
    return <p className="text-slate-700">{t('helpCenter.loading')}</p>;
  }

  if (status === 'error') {
    return <p className="text-slate-700">{t('helpCenter.load_error')}</p>;
  }

  const categoryArticles = articles.filter((article) => article.category === category);
  if (categoryArticles.length === 0) {
    return <p className="text-left text-slate-700">{t('helpCenter.empty')}</p>;
  }

  return (
    <ul className="space-y-3 text-left">
      {categoryArticles.map((article) => (
        <li key={article.slug}>
          <Link
            className="text-lg font-medium text-slate-900 hover:text-slate-700"
            to={`/help-center/${article.slug}`}
          >
            {article.title}
          </Link>
        </li>
      ))}
    </ul>
  );
};

const HelpCenterCategoryPage = () => {
  const { category } = useParams<{ category: string }>();
  const { t } = useTranslation();

  if (!category || !isHelpCenterCategory(category)) {
    console.error('Invalid Help Center category', { category });
    return (
      <HelpCenterLayout>
        <p className="text-left text-slate-700">{t('helpCenter.article_error')}</p>
      </HelpCenterLayout>
    );
  }

  return (
    <HelpCenterLayout
      activeCategory={category}
      header={
        <>
          <Title text={t(`helpCenter.category.${category}`)} />
          <p className="mt-4 text-slate-700">{t(`helpCenter.category.${category}.description`)}</p>
        </>
      }
    >
      <CategoryArticleList category={category} />
    </HelpCenterLayout>
  );
};

export default HelpCenterCategoryPage;
